var timeout = false;
var rtime;
var delta = 200;

var applicationsCarousel = {
	init:function(){
	
		var applications_carousel = $('.applications .applications-carousel').slick({
			centerMode: false,
			centerPadding: 0,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			arrows:false,
			dots:false,			
		});

		applications_carousel.on('afterChange', function(){
			var index = Number($('.applications .applications-carousel .slick-slide.slick-current').data('slick-index'));						
			$('.applications .applications-grid .item').removeClass('active');
			$('.applications .applications-grid .item[data-index="'+index+'"]').addClass('active');			
			if($('.applications .applications-grid .item.slick-slide.slick-active').length<5){
				applications_carousel_thumps.slick('slickGoTo', index ); 	
			}
		});

		$('.applications .applications-grid .item').click(function(){
			var $this = $(this);
			var $index = $this.data('index');			
			$('.applications .applications-grid .item').removeClass('active');
			$this.addClass('active');
			applications_carousel.slick('slickGoTo', $index ); 
		});		

		var applications_carousel_thumps = $('.applications .applications-grid').slick({
			centerMode: false,
			centerPadding: 0,
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite:true,
			speed: 500,			
			cssEase: 'linear',
			responsive: [
				{
                    breakpoint: 1601,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, 
                {
                    breakpoint: 992,
                    settings: {
                    	centerMode: true,			
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {

                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]				
		});

	} 
};



var productNewReview = {
	init : function(){
		$('.write-review-modal .reviews .star').mouseover(function(){
			var $this = $(this);
			var $value = $this.data('value');
			for(var $i = 1; $i <= $value;$i++){
				$('.write-review-modal .reviews .fa-star-'+$i).addClass('hover');	
			}
		});
		$('.write-review-modal .reviews .star').mouseleave(function(){
			$('.write-review-modal .reviews .fa-star').removeClass('hover');	
		});
		$('.write-review-modal .reviews .star').click(function(){
			var $this = $(this);
			var $value = $this.data('value');
			$('.write-review-modal form input[name="review"]').val($value);			
			$('.write-review-modal .reviews .fa-star').removeClass('active');	
			for(var $i = 1; $i <= $value;$i++){
				$('.write-review-modal .reviews .fa-star-'+$i).addClass('active');	
			}
		});
	}	
};



	

var homepageCategoryProductsSlider = {	
	init : function(){
		var CategoryProducts_carouselSlider = $('.category-products .category-products-slider-content').slick({
            dots: false,
            arrows:false,
            nav:false,
            infinite: false,
            speed: 300,
			swipeToSlide : true,
            slidesToShow: 4,
            arrows: true,
            appendArrows: $(".category-products.with-slider .nav-carousel .arrows"),
			prevArrow: $('.category-products .category-products-slider-content').data('prevarrow'),
			nextArrow: $('.category-products .category-products-slider-content').data('nextarrow'),
			responsive: [
				{
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });		
		$('.category-products.with-slider .left').click(function(){
            CategoryProducts_carouselSlider.slick('slickPrev');
            return false;
        });
        $('.category-products.with-slider .right').click(function(){
            CategoryProducts_carouselSlider.slick('slickNext');
            return false;
        });
	}
}

var productOptions = {

	init : function(){
		if($('.product-details .tab-general .option-filter').length===0){
			$('.product-details .tab-general .side-panel .product-options .compare-prices .btn.disabled').removeClass('disabled');
		}
		$('.product-details .tab-general .option-filter select').change(function(){
			console.log($(this).val());
			var empty = false;
			if($(this).val()==''){
				$('.product-details .tab-general .side-panel .product-options .compare-prices .btn').addClass('disabled');
			}else{
				$('.product-details .tab-general .option-filter select').each(function(){
					if($(this).val()==''){
						empty = true;	
					}
				});

				if(!empty){
					$('.product-details .tab-general .side-panel .product-options .compare-prices .btn.disabled').removeClass('disabled');
				}
			}			
		});
		$('.product-details  .product-options .quantity-input .control').click(function(){
			var $this = $(this);
			var $input = $('.product-details  .product-options .quantity-input input');
			var $value = Number($input.val());
			if($this.hasClass('plus')){
				$input.attr('value' , $value + 1);
			}else if($value > 1){
				$input.attr('value' , $value - 1);
			}
		}); 
		
	}	
};

var productVideos = {

	init : function(){
		
		 var image_scarousel_main = $('.product_videos .product_videos_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			fade: true,	
			appendArrows: $('product_videos'),
			prevArrow: $('.product_thumbs .product_thumbs_carousel').data('arrow-prev'),
			nextArrow: $('.product_thumbs .product_thumbs_carousel').data('arrow-next'),			
		});
		
		$('.product_thumbs_main .carousel-controls .left').click(function(){
			image_scarousel_main.slick('slickPrev');
			return false;
        });
        $('.product_thumbs_main .carousel-controls .right').click(function(){
            image_scarousel_main.slick('slickNext');
            return false;
        });

	},
}

var productImages = {

	init : function(){		
		
		var carousel_items = $('.product_thumbs .product_thumbs_carousel .item').length;
		
		if(carousel_items==0){
			$('.product_image .carousel-controls').removeClass('visible-xs');
			$('.product_image .carousel-controls').addClass('hidden');
		}
		
		var image_scarousel_main = $('.product_thumbs_main .product_thumbs_carousel_main').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			//asNavFor: '.product_thumbs .product_thumbs_carousel'		
		});
		
		$('.product_thumbs_main .carousel-controls .left').click(function(){
			image_scarousel_main.slick('slickPrev');
			return false;
        });
        $('.product_thumbs_main .carousel-controls .right').click(function(){
            image_scarousel_main.slick('slickNext');
            return false;
        });		
	
		var start_items;
		var responsive_items;	
		if(carousel_items > 5){
			start_items  = 5;
		}else{
			start_items = carousel_items;
		}
		if(carousel_items > 4){
			responsive_items  = 4;
		}else{
			responsive_items = carousel_items;
		}
		
		
		$('.product_thumbs').on('init', function(slick, currentSlide){
			$('.product_thumbs .product_thumbs_carousel .item.slick-current').addClass('thumb-active');			
		});
		var product_thumbs_vertical = true;
		if( $('.product_thumbs .product_thumbs_carousel').hasClass('slick-horizontal') ){
			product_thumbs_vertical = false;
		}
		$('.product_thumbs').imagesLoaded( function() {
			setTimeout(function(){

				var options_desktop = {
					arrows:  		 true,
					dots:  			 false,
					slidesToScroll:  1, 					
					rows: 			 6,
					slidesPerRow:  	 2,
					draggable:  	 true,
					infinite:  		 false,
					swipe:  		 true,
 					swipeToSlide:    true,
					verticalSwiping: product_thumbs_vertical,
					vertical:  		 product_thumbs_vertical,
					asNavFor:  		 '.product_thumbs_carousel_main', 
					focusOnSelect:   true,
					appendArrows:  	 $('.product-details .tab-general .block-left .product_thumbs .controls'),
					prevArrow:  	 $('.product_thumbs .product_thumbs_carousel').data('arrow-prev'),
					nextArrow:  	 $('.product_thumbs .product_thumbs_carousel').data('arrow-next'),
					responsive: [
						{
		                    breakpoint: 768,		                   
		                },
					]
				};

				var options_mobile = {
					arrows:  		 true,
					dots:  			 false,
					slidesToScroll:  1, 										
					slidesToShow: 	 5,
					draggable:  	 true,
					infinite:  		 false,
					swipe:  		 true,
 					swipeToSlide:    true,					
					asNavFor:  		 '.product_thumbs_carousel_main', 
					focusOnSelect:   true,
					appendArrows:  	 $('.product-details .tab-general .block-left .product_thumbs .controls'),
					prevArrow:  	 $('.product_thumbs .product_thumbs_carousel').data('arrow-prev'),
					nextArrow:  	 $('.product_thumbs .product_thumbs_carousel').data('arrow-next'),
					responsive: [					
		                {
		                    breakpoint: 768,		                   
		                },
		                {
		                    breakpoint: 600,
		                    settings: {
		                        slidesToShow: 4,
		                    }
		                },
		                {
		                    breakpoint: 480,
		                    settings: {
		                        slidesToShow: 3,
		                    }
		                },
		                {
		                    breakpoint: 390,
		                    settings: {
		                        slidesToShow: 2,
		                    }
		                },		                
					]
				};
				var thumbs_carouser ;
				if($('body').innerWidth()>767){
					thumbs_carouser = $('.product_thumbs .product_thumbs_carousel').slick(options_desktop);
				}else{
					thumbs_carouser = $('.product_thumbs .product_thumbs_carousel').slick(options_mobile);
				}

				thumbs_carouser.on('breakpoint', function(e){
					console.log(e);
					thumbs_carouser.slick('unslick');
					if($('body').innerWidth()>767){
						thumbs_carouser = $('.product_thumbs .product_thumbs_carousel').slick(options_desktop);
					}else{
						thumbs_carouser = $('.product_thumbs .product_thumbs_carousel').slick(options_mobile);
					}
									
				});



				$('.product_thumbs .product_thumbs_carousel a').click(function(e){
					if(!$(this).hasClass('rotate-trigger')){
						var $this = $(this);				
						var index = $this.data('thumb-slick-index');							
						image_scarousel_main.slick("goTo", index);
						e.preventDefault(0);	
						return false;
					}				
				});
			},500); 
			
		});		
	},
	
	priceAlertForm : function(form){
		$(form).parsley();
		$(form).on('submit',function($e){
			$.ajax({
				url: $(form).attr('action'),
				data: $(form).serialize(),
				success: function (data) {
					if (data.status == "ok") {
						actionResponseModal(data.message,'success');
					} else if (data.status == 'error') {
						actionResponseModal(data.error,'error');
					} else {
						actionResponseModal(LOCALE.general_error,'error');
					}
				},
				error:function(d){
					if(d.responseJSON.error){
						actionResponseModal(d.responseJSON.error,'error');
					}else{
						actionResponseModal(LOCALE.general_error,'error');                    
				   }
				}
			});
			$e.preventDefault();
		});
	}
	
	
};

var spotlightsProducts = {
	init : function(){
		var spotlights_carousel = $('.spotlights-products .spotlights-carousel').slick({
            dots: false,
            arrows:false,
            nav:false,
            infinite: false,
			swipeToSlide : true,
            speed: 300,
            slidesToShow: 1,
        });
        spotlights_carousel.on('afterChange', function(){
			var index = $('.spotlights-products .slick-current').data('slick-index');
			$('.spotlights-products .carousel-pages li.active').removeClass('active');
			$('.spotlights-products .carousel-pages li.page-'+index).addClass('active');
        });
        $('.spotlights-products .left').click(function(){
            spotlights_carousel.slick('slickPrev');
            return false;
        });
        $('.spotlights-products .right').click(function(){
            spotlights_carousel.slick('slickNext');
            return false;
        });
		$('.spotlights-products .carousel-pages li').click(function(){
			spotlights_carousel.slick("goTo", $(this).data('index'));
		});
	}	
};


$(window).resize(function(){
	equalizeHeight('.product-details .tab-general .eq-block');
});

var homeCategoryProducts = {	
	init : function(){
		var target = '.category-products .eq-height .product-grid-item,.category-products .eq-height .banner-item';
	    equalizeHeight(target);
		equalizeHeight('.banner-item-tall,.eq-height-banner');

        $(window).resize(function(){
			var rtime = new Date();
			if (timeout === false) {
				timeout = true;
				resizedeltaFunction(target);
				equalizeHeight('.banner-item-tall,.eq-height-banner');
			}
		});
		var CategoryProducts_carousel = $('.category-products .nav-carousel .nav').slick({
            dots: false,
            arrows:false,
            nav:false,
            infinite: false,
            speed: 300,
            slidesToShow: 7,
			swipeToSlide : true,
			responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $('.category-products .nav-carousel .nav a').click(function(){
        	$('.category-products .nav-carousel .active').removeClass('active');
        });
		$('.category-products .nav-carousel .left').click(function(){
            CategoryProducts_carousel.slick('slickPrev');
            return false;
        });
		$('.category-products .nav-carousel .right').click(function(){
            CategoryProducts_carousel.slick('slickNext');
            return false;
        });	
	}
}

var featuredProducts = {
    init : function(){
    	var target = '.featured-products .eq-height > div,.featured-products .eq-height > a';
        equalizeHeight(target);		
        $(window).resize(function(){
			var rtime = new Date();
			if (timeout === false) {
				timeout = true;
				resizedeltaFunction(target);
				
			}
		});
    }
}
var latestProducts = {
    init : function(){
    	var width_latest = $(window).width(); 
    	var target = '.latest-products .eq-height > div,.latest-products .eq-height > a';
        equalizeHeight(target);		
        $(window).resize(function(){
        	if ($(window).width()==width_latest) return; 
    		width_latest = $(window).width();
			var rtime = new Date();
			if (timeout === false) {
				timeout = true;
				resizedeltaFunction(target);
				
			}
		});

		$slider = $('.latest-products .products-grid.slider.grid_size-4');
		var $slider_4_carousel = $slider.slick({
            dots: false,
            arrows:false,
            nav:false,
            infinite: false,
            speed: 300,
			swipeToSlide : true,
            slidesToShow: 4,
            arrows: false,            
			responsive: [
				{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },               
                { 
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }                
            ]
        });	 

		$slider_3 = $('.latest-products .products-grid.slider.grid_size-3');
		var $slider_3_carousel = $slider_3.slick({
            dots: false,
            arrows:false,
            nav:false,
            infinite: false,
            speed: 300,
			swipeToSlide : true,
            slidesToShow: 3,
            arrows: false,            
			responsive: [
                { 
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }                
            ]
        });	
    }
}


function resizedeltaFunction(target){	
	if (new Date() - rtime < delta) {
        setTimeout(resizedeltaFunction, delta);
    } else {
        timeout = false;		
		equalizeHeight(target);
    }	
}

function equalizeHeight(target,offset) {
	$(target).each(function(){
		$(target).css('min-height','auto');
	});	
    var min_height = 0;
    setTimeout(function(){
        $(target).each(function(){
            if($(this).innerHeight() > min_height){
                min_height = $(this).innerHeight();
            }
        });
        if(min_height>0){
            $(target).css('min-height',min_height);
        }
		$(target).each(function(){			 
			$(target).removeClass('autoHeight');
			
			if($(this).hasClass('banner-item-tall')){
				$(this).css('min-height',$(target).innerHeight()-13);
			}
		});
    },500);	
}

var detailsMapProduct = {		
	init : function(locations,free_locations){
		$('.map-switch input[type="checkbox"]').change(function(){
			var $this = $(this);
			if($this.is(":checked")){
				setTimeout(function(){
					initProductMap(locations);	
				},400);
			}			
			$(window).resize(function(){
				if($('.map-block').hasClass('in')){
					if($('.free-shipping input[type="checkbox"]').is(":checked")){
						initProductMap(free_locations);
					}else{
						initProductMap(locations);
					}
				}
			});
		});	
		
		$('.free-shipping input[type="checkbox"]').change(function(){
			var $this = $(this);			
			if($this.is(":checked")){
				locations.forEach(function(item) {
					if(item['free']!==1){
						$('#price-list table tbody tr.store-'+item['id']).addClass('hidden');
					}					
				});				
				initProductMap(free_locations);				
			}else{
				initProductMap(locations);				
				$('#price-list table tbody tr.hidden').removeClass('hidden');
			}
		});	
		
		
		$('.enter-zipcode-content input').on('keyup',function($e){
			var zip = $('.enter-zipcode-content input').val();
			if($('.free-shipping input[type="checkbox"]').is(":checked")){
				var _locations = free_locations;
			}else{
				var _locations = locations;
			}	
			if(!zip == ''){
				var zip_locations = [];
				_locations.forEach(function(item) {
					console.log(item['zip']+' '+zip);
					if(item['zip']== zip){
						zip_locations.push(item);	
					}else{
						$('#price-list table tbody tr.store-'+item['id']).addClass('hidden');
					}
				});
				initProductMap(zip_locations);
			}else{
				initProductMap(_locations);
			}
			$e.preventDefault();
		})
	}
};

function saveProduct($this){
	var action = 'save';
	if($this.hasClass('saved')){
		action = 'remove';
	}

	$.ajax({
		type: "POST", 
		url: "/api/save-product", 
		data: { 
			id: $this.data('id'), 
			action: action
		},
		success:function(data){
			if(data.status === 'ok'){

                if($('.save-product[data-id="'+$this.data('id')+'"]').closest('.partial').length > 0 && !$('body').hasClass('product-details')){
                	$('.save-product[data-id="'+$this.data('id')+'"]').closest('.partial').each(function(){                		
                		load_partial($(this));
                	});
                }else{
                	if(action === 'save'){
						$('.save-product[data-id="'+$this.data('id')+'"]').addClass('saved');					
					}else{
						$('.save-product[data-id="'+$this.data('id')+'"]').removeClass('saved');
					}
                }
				actionResponseModal(data.message,'success','.actions-block .save');
			}else{
				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	});
}



var FactoryTireSizes = {
	modal : '.factory-tire-sizes',
	init : function(){
		var endpoint = '/partial/products.factory-tire-sizes';
		/*
		del = '?route=catalogue/products&limit=4&with=shortcode&';
		for(var i in $data){
			endpoint+= del +  (i+"="+$data[i]); 
			$('.factory-tire-sizes-partial').data(i,$data[i] );	
			del = '&';
		}
		*/
		$.ajax({ 
			url: endpoint,  
			success:function(data){							
				$('#ajax-content').append(data.markup);
				skinFormElements(FactoryTireSizes.modal); 
				//load_partial($('.upsales-options-partial'));				
				$(FactoryTireSizes.modal).modal('show').on('hidden.bs.modal', function () {				
	                $(FactoryTireSizes.modal).remove();
	            }); 
			},
			error:function(d){
	         	console.log(d);
	        }
		}); 	
	}
};  